import axios from 'axios';
import logger from '../logger';

// Some extra things we might need to do before we can load the app
// For example authenticating a user
export async function authenticatingUser() {
  try {
    const res = await axios.get('/auth/current_user');
    return res.data;
  } catch (err) {
    logger.error(err);
    return err;
  }
}

export function logoutUser(): void {
  window.location.href = '/auth/logout';
}
